/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const servicesMessages = defineMessages({
    mainTitle: {
        id: 'portal.homePageServices.mainTitle',
        defaultMessage: 'Related products and services'
    },
    subTitle: {
        id: 'portal.homePageServices.subTitle',
        defaultMessage: 'Check out the channels, tools, and service integrations that have people talking'
    },
    azureBotServiceTitle: {
        id: 'portal.homePageServices.azureBotServiceTitle',
        defaultMessage: 'Azure Bot Service'
    },
    azureBotServiceDescription: {
        id: 'portal.homePageServices.azureBotServiceDescription',
        defaultMessage: 'Azure Bot Service'
    },
    qnaTitle: {
        id: 'portal.homePageServices.qnaTitle',
        defaultMessage: 'QnA Maker'
    },
    qnaDescription: {
        id: 'portal.homePageServices.qnaDescription',
        defaultMessage: 'Go from FAQ to Bot in minutes with no coding required'
    },
    textAnalyticsTitle: {
        id: 'portal.homePageServices.textAnalyticsTitle',
        defaultMessage: 'Text Analytics API'
    },
    textAnalyticsDescription: {
        id: 'portal.homePageServices.textAnalyticsDescription',
        defaultMessage: 'Easily evaluate sentiment and topics to understand what users want'
    },
    bingSpellTitle: {
        id: 'portal.homePageServices.bingSpellTitle',
        defaultMessage: 'Bing Spell Check'
    },
    bingSpellDescription: {
        id: 'portal.homePageServices.bingSpellDescription',
        defaultMessage: 'Detect and correct spelling mistakes in your app'
    },
    bingSpeechTitle: {
        id: 'portal.homePageServices.bingSpeechTitle',
        defaultMessage: 'Bing Speech API'
    },
    bingSpeechDescription: {
        id: 'portal.homePageServices.bingSpeechDescription',
        defaultMessage: 'Convert speech to text and back again to understand user intent'
    },
    azureSearchTitle: {
        id: 'portal.homePageServices.azureSearchTitle',
        defaultMessage: 'Azure Search'
    },
    azureSearchDescription: {
        id: 'portal.homePageServices.azureSearchDescription',
        defaultMessage: 'Surface the power of searching data in your application'
    },
    learnMoreAzureService: {
        id: 'portal.homePageServices.learnMoreAzureService',
        defaultMessage: 'Learn more about Azure service'
    },
    learnMoreQnAMaker: {
        id: 'portal.homePageServices.learnMoreQnAMaker',
        defaultMessage: 'Learn more about QnA Maker'
    },
    learnMoreTextAnalytics: {
        id: 'portal.homePageServices.learnMoreTextAnalytics',
        defaultMessage: 'Learn more about Text Analytics API'
    },
    learnMoreBingSpellCheck: {
        id: 'portal.homePageServices.learnMoreBingSpellCheck',
        defaultMessage: 'Learn more about Bing Spell Check'
    },
    learnMoreBingSpeech: {
        id: 'portal.homePageServices.learnMoreBingSpeech',
        defaultMessage: 'Learn more about Bing Speech API'
    },
    learnMoreAzureSearch: {
        id: 'portal.homePageServices.learnMoreAzureSearch',
        defaultMessage: 'Learn more about Azure Search'
    }
});
